import axios from 'axios';
import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

export function apiValidationErrorHandler<T extends FieldValues>(
  setError: UseFormSetError<T>,
) {
  return (error: unknown): void => {
    if (!(axios.isAxiosError(error) && error.response)) {
      return;
    }
    const { status, data } = error.response;
    if (
      status !== 422 ||
      !data ||
      typeof data !== 'object' ||
      !('errors' in data) ||
      !data.errors ||
      typeof data.errors !== 'object'
    ) {
      return;
    }
    const errors = data.errors as Record<string, string[] | string>;
    for (const [field, messages] of Object.entries(errors)) {
      const message = Array.isArray(messages) ? messages[0] : messages;
      if (message && typeof message === 'string') {
        setError(field as Path<T>, { type: 'server', message });
      }
    }
  };
}
